module.exports = __webpack_public_path__ + "img/NL_workerInfo_editBankAccount.e2f1aa11.png";